import Order from "../models/Order";
import OrderItem from "../models/OrderItem";

/**
 * Calculates the total amount for a list of order items.
 *
 * @param {Array<{ quantity: number, amount: number }>} orderItems - The list of order items.
 * @returns {number} The total amount (sum of quantity * amount for all items).
 */
export function orderItemsTotal(orderItems?: OrderItem[]) {
  if (!Array.isArray(orderItems)) return 0;

  return orderItems.reduce(
    (sum, item) => sum + (item.amount ?? 0),
    0
  );
}

export function orderTotal(
  orders?: Order[]
): { totalPaid: number, totalPending: number } {
  const total = { totalPaid: 0, totalPending: 0 };

  if (!orders) return total;

  for (const order of orders) {
    if (order.isPaid) total.totalPaid += orderItemsTotal(order.orderItems);
    else total.totalPending += orderItemsTotal(order.orderItems);
  }
  return total;
}